import React from "react";
import SubAdminPageSectoin from "../../Sections/SubAdminPageSection/Content";
const SubAdminPage = () => {
  return <SubAdminPageSectoin />;
};

export default SubAdminPage;
